module.exports = "/_next/static/images/357a28d7d2be4f3d0893974456b9627c-google-wallet-mini.png.webp";